<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Wohnlage der Wohnung
            </h1>
        </div>
        <p class="validationError" role="alert" v-if="validationError">
            <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
        </p>
        <div class="mb-5">
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" :aria-activedescendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected" >
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('wohnlage.' + item.id)">
                                <v-list-item-content aria-hidden="true" class="d-flex flex-wrap" style="color: black; margin-left: 8px">
                                    <v-list-item-title v-text="$t('wohnlage.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- STADTPLANPROGRAMM -->
        <div class="d-flex flex-column justify-center">
            <h2 class="my-3">Wohnlagensuche</h2>
            <autocomplete :search="search" ref="addressInput" @submit="updateGeoLink" placeholder="Straße und Hausnummer" aria-label="Straße und Hausnummer" :get-result-value="getResultValue">
            </autocomplete>
            <v-btn class="mb-3" style="margin-top: 24px;" @click="openGeoportal(_prepareLink(lage))" target="_blank" outlined large color="indigo"><span class="black--text subtitle-1">zum Stadtplanprogramm</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Wohnlage</h3><br/>
                            <p>Die Wohnlage kann mit Hilfe des Stadtplanprogramms für die jeweilige Mietwohnung bestimmt werden. Bitte beachten Sie, dass in Ihrem Browser die Option "Javascript" für das Stadtplanprogramm aktiviert ist.</p>
                            <p>Geben Sie bitte zunächst Straße und Hausnummer ein und gehen Sie dann zum Stadtplanprogramm.</p>
                            <p>Die Eingabe eines Buchstabens startet die Adresssuche.
                            Wurde ein eindeutiger Straßenname ausgewählt,
                            ermöglicht die Eingabe eines nachfolgenden Leerzeichens
                            die Auswahl einer Hausnummer.
                            </p>

                            <h3>Wohnlagendefinition</h3><br/>
                            <p>
                            Im Mietspiegel für München 2025 werden sechs Wohnlagenkategorien ausgewiesen.
                            Die Einteilung der Wohnlagen erfolgte zunächst unter Berücksichtigung der Bodenrichtwerte sowie
                            des näheren Wohnumfeldes wie zum Beispiel Bestand an Grün- und Freiflächen beziehungsweise der Infrastruktur.
                            Im Rahmen der statistischen Datenanalyse zeigte sich wie bereits im Mietspiegel für München 2023
                            ein signifikanter Einfluss der Lage der Wohnungen innerhalb des Stadtgebietes (sogenannte Makrolage) auf den Mietpreis.
                            Die Integration der Makrolage machte es auch im Mietspiegel für München 2025 notwendig, zentrale Wohnlagenkategorien
                            (zentrale durchschnittliche, zentrale gute und zentrale beste Lage) auszuweisen.
                            </p>

                            <h3>Durchschnittliche Lage - hellblau</h3><br/>
                            <p>Gebiete ohne die Mängel einer einfachen und ohne die Vorzüge der guten Lage.
                            "Durchschnittlich" bezieht sich dabei auf einen qualitativen Unterschied der Lage und ist im Sinne
                            von "weder besonders gut noch besonders schlecht" zu verstehen.
                            </p>

                            <h3>Gute Lage - gelb</h3><br/>
                            <p>Gefragte Innenstadtrandlagen und größere Neubaugebiete mit überwiegend guter Gebietsstruktur sowie ruhige Wohngegenden
                            mit Gartenstadtcharakter, ausreichender Infrastruktur und positivem Image.
                            </p>

                            <h3>Beste Lage - hellrot</h3><br/>
                            <p>Besonders imageträchtige Innenstadt- und innenstadtnahe Lagen und traditionelle Villengegenden.
                            </p>

                            <h3>Zentrale durchschnittliche Lage - dunkelblau</h3><br/>
                            <p>Zentrale Gebiete, die die Kriterien der durchschnittlichen Lage erfüllen und für die im Rahmen der statistischen Analyse der Daten höhere Mietpreise identifiziert wurden.
                            </p>

                            <h3>Zentrale gute Lage - orange</h3><br/>
                            <p>Zentrale Gebiete, die die Kriterien der guten Lage erfüllen sowie traditionell sehr gefragte Innenstadtlagen
                            und innenstadtnahe Lagen mit sehr gut gewachsener Gebietsstruktur, überdurchschnittlichem Anteil an denkmalgeschützten
                            Gebäuden, urbane „In-Viertel“. In diesen Gebieten wurden im Rahmen der statistischen Analyse der Daten höhere
                            Mietpreise identifiziert.
                            </p>

                            <h3>Zentrale beste Lage - dunkelrot</h3><br/>
                            <p>Zentrale Gebiete, die die Kriterien der besten Lage erfüllen und für die im Rahmen der statistischen Analyse der
                            Daten höhere Mietpreise identifiziert wurden.
                            </p>

                            <h3>Weitere Informationen</h3><br/>
                            <p>Bei Straßenlärm oder sonstigen Immissionen ausgesetzten Lagen, die erheblich von der sonstigen gebietstypischen
                            Lageeinteilung abweichen, sind teilweise bereits Lageabstufungen als farbige Linien im Stadtplan vorgegeben.</p>
                            <p>Diese Linien sind vereinzelt auch für Lageaufwertungen angegeben. Lageabstufungen an verkehrsbelasteten Straßen
                            beziehen sich nur auf die erste Häuserzeile.</p>
                            <p>Für Gewerbegebiete mit Wohnungen und nach dem Erhebungsmonat Januar 2024 fertiggestellte Neubaugebiete
                            wurden nur in Ausnahmefällen Wohnlagenbewertungen vorgenommen. Dies gilt auch für wesentliche Änderungen der Wohnlagenqualität.
                            Hier ist im Einzelfall eine individuelle Lagezuordnung vorzunehmen. Die Qualität der umliegenden Wohngebiete kann dabei eine Orientierungshilfe sein.
                            </p>
                            <p>Hinsichtlich der <b>Lageabstufungen</b> ist für die Wohnlagenbestimmung nicht die Adressenlage einer Wohnung, sondern die
                            tatsächliche Lage im Vorder- oder Rückgebäude des Anwesens und die damit verbundenen Beeinträchtigungen maßgebend.</p>
                            <p>Die <b>Klassifizierung der Wohnlagen</b> erfolgte nach der durchschnittlichen Lagequalität der einzelnen Gebiete.
                            Abweichungen der individuellen Lage von der gebietstypischen Lage können im Einzelfall die Zuordnung
                            zu einer anderen Lagequalität notwendig machen.</p>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { createNamespacedHelpers, mapMutations } from 'vuex';
    import EnvironmentInfoService from '@/api/EnvironmentInfoService';

    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        computed: { ...mapGetters(['hasPermission']) },
        methods: { ...mapMutations('berechnung', ['SET_SELECTED_WOHNLAGE']), ...mapMutations('search', ['SET_QUERY']) }
    })
    export default class Wohnlage extends Vue {

        data() {
            return {
                index: 4,
                selectedItem: this.$store.state.berechnung.selectedWohnlage,
                lage: this.$store.state.search.query,
                items: [
                    { id: 0},
                    { divider: true},
                    { id: 1},
                    { divider: true},
                    { id: 2},
                    { divider: true},
                    { id: 3},
                    { divider: true},
                    { id: 4},
                    { divider: true},
                    { id: 5},
                ],
                validationError: false,
                expanded: false,
                geokartenUrl: '',
                geokartenWohnlageUrl: ''
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        updateGeoLink(result){
            this.lage = result._source?.properties?.address
        }

        openGeoportal(address){
            window.open(this.geokartenWohnlageUrl + address);
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        search(input) {
            this.$data.lage = input;
            const url = this.$root.$children[0].getBackendUrl() + `/api/backend-service/adresssuche?searchString=${input}`;

            return new Promise((resolve) => {
            if (input.length < 3) {
                return resolve([])
            }
            fetch(url)
                .then((response) => response.json()
                    .then(data => {
                        if(!data || !data.hits) {
                            resolve([])
                        }
                        // Extract List from response
                        resolve(data?.hits?.hits)
                    })
                )
            })
        }

        getResultValue(result) {
          return result._source?.properties?.address
        }

        _prepareLink(lage) {
            return lage.replace(' ', '%20')
        }

        geoPostMessage(event, vm){
            if(event.origin !== "https://maps.muenchen.de" && event.origin !== this.geokartenUrl) return;
            if(!event.data.lage) return;
            vm.selectedItem = parseInt(event.data.lage)
            //set in result format
            vm.$refs.addressInput.setValue({ label: event.data.address })
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.addressInput.setValue({ label: this.$store.state.search.query })
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            window.addEventListener('message', event => this.geoPostMessage(event, vm))
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
            if(window.location.hash.split('info=')[1] === "wohnlage"){
                this.$refs.infoPanel.toggle()
                setTimeout(() => {
                    this.$refs.infoPanel.$el.scrollIntoView()
                }, 500);
                this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', true)
            }

            EnvironmentInfoService.getEnvironmentInfo().then((value) => {
                this.geokartenUrl = value.geokartenUrl
                this.geokartenWohnlageUrl = value.geokartenWohnlageUrl
            }).catch((reason) => {
                console.log(reason)
            });
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
       }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedItem)
            this.SET_SELECTED_WOHNLAGE(this.selectedItem)
            this.SET_QUERY(this.lage)
            this.$router.push('gebaeudetyp')
        }

        back() {
            this.$router.push('baujahr')
        }
    }
</script>
